"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getMessage", {
  enumerable: true,
  get: function get() {
    return _getMessage["default"];
  }
});
var _getMessage = _interopRequireDefault(require("./getMessage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/lib/index.js
// module id = 124
// module chunks = 0